import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const CounterStrike = () => {
  return (
    <SportsLayoutComp name={'Counter Strike'}/>
  )
}

export default CounterStrike